var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDev10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.71 56.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#66519d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App_web_dev",
    "data-name": "App web dev"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.24,0,8.36.23A7,7,0,0,1,13.87,8.1a25.12,25.12,0,0,1-3.29,9.12c-.63,1.13-1.31,2.22-2,3.3a1.82,1.82,0,0,1-3.11,0,36.09,36.09,0,0,1-5-10.31A9.27,9.27,0,0,1,.3,5,7,7,0,0,1,6.21.13,1.93,1.93,0,0,0,6.68,0ZM1.47,7.18c.12.76.19,1.53.38,2.28A34.54,34.54,0,0,0,6.6,19.55c.27.43.51.42.79,0a34.62,34.62,0,0,0,4.45-9A9.29,9.29,0,0,0,12.3,6a5.4,5.4,0,0,0-6-4.31A5.51,5.51,0,0,0,1.47,7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.71,42.49a17.38,17.38,0,0,1-.36,2.16c-.4,1.41-.86,2.81-1.33,4.2-.2.59-.55.75-1,.58s-.62-.57-.38-1.14A23.13,23.13,0,0,0,55,43.54a5.59,5.59,0,0,0-4.51-6.69,5.49,5.49,0,0,0-6.27,4.81A12.77,12.77,0,0,0,45.72,48c1.06,2.24,2.31,4.4,3.5,6.57.33.61.57.6.94,0s.92-1.47,1.38-2.2c.31-.5.64-.6,1.05-.37a.72.72,0,0,1,.25,1.12c-.52.87-1,1.75-1.61,2.58a1.82,1.82,0,0,1-3,.08A34.35,34.35,0,0,1,43,44.47,7.23,7.23,0,0,1,44.5,37.6a7,7,0,0,1,12.08,3.82,3.24,3.24,0,0,0,.13.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,24.36h6.53c1.16,0,1.68.53,1.68,1.7V38.94a1.52,1.52,0,0,1-1.72,1.74H17.38A1.49,1.49,0,0,1,15.7,39q0-6.51,0-13a1.51,1.51,0,0,1,1.67-1.67C19.58,24.38,21.79,24.36,24,24.36Zm-6.74,8.17v5.86c0,.8,0,.8.77.8H29.92c.76,0,.77,0,.77-.78V30c0-1.2,0-2.4,0-3.59,0-.42-.12-.6-.57-.58-.77,0-1.55,0-2.32,0-.43,0-.58.13-.58.57,0,1.51,0,3,0,4.53,0,.84-.25,1.1-1.07,1.1H21.73c-.79,0-1.06-.27-1.06-1.06,0-1.53,0-3.06,0-4.59,0-.4-.11-.56-.53-.55-.76,0-1.51,0-2.27,0-.47,0-.64.11-.63.61C17.28,28.48,17.26,30.5,17.26,32.53Zm8.38-4.36c0-.61,0-1.21,0-1.82,0-.34-.1-.51-.48-.5H22.62c-.35,0-.45.15-.45.46,0,1.24,0,2.47,0,3.71,0,.36.16.48.51.47q1.24,0,2.49,0c.37,0,.49-.15.48-.49C25.63,29.39,25.64,28.78,25.64,28.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,14.53c3.76,0,7.52,0,11.29,0a9.35,9.35,0,0,1,1.15,18.63c-1.38.15-2.79.09-4.19.11a.71.71,0,0,1-.76-.76.72.72,0,0,1,.8-.73c1.23,0,2.47,0,3.7-.09a7.84,7.84,0,0,0,.75-15.51A8.92,8.92,0,0,0,38.06,16h-23c-.67,0-.92-.18-1-.65a.68.68,0,0,1,.72-.83H27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.05,42.37a3.35,3.35,0,0,1-3.38,3.4,3.4,3.4,0,1,1,0-6.79A3.32,3.32,0,0,1,53.05,42.37Zm-5.24,0a1.88,1.88,0,0,0,1.88,1.9,1.91,1.91,0,0,0,0-3.81A1.86,1.86,0,0,0,47.81,42.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.24,50.3a1,1,0,0,1-.82.75.79.79,0,0,1-.76-.78.81.81,0,0,1,.74-.75A1,1,0,0,1,26.24,50.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.11,33.26a.72.72,0,0,1-.73-.73.74.74,0,1,1,1.47,0A.73.73,0,0,1,9.11,33.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.78,42A.81.81,0,0,1,0,41.28a.76.76,0,0,1,.71-.76.77.77,0,0,1,.82.72A.82.82,0,0,1,.78,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.31,43.75a.8.8,0,0,1,.77.72.76.76,0,0,1-1.52,0A.77.77,0,0,1,1.31,43.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.85,50.31a.74.74,0,0,1-.74.73.77.77,0,0,1-.73-.75.79.79,0,0,1,.78-.77A.77.77,0,0,1,12.85,50.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.17,50.27a.75.75,0,0,1-.7.78.79.79,0,0,1-.77-.78.8.8,0,0,1,.75-.75A.76.76,0,0,1,16.17,50.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.49,50.28a.74.74,0,0,1-.71.76.77.77,0,0,1-.76-.73.79.79,0,0,1,.76-.79A.76.76,0,0,1,19.49,50.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.34,50.3a.8.8,0,0,1,.72-.78.76.76,0,0,1,.75.73.74.74,0,0,1-.73.79A.77.77,0,0,1,21.34,50.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.56,50.27a.75.75,0,0,1-.7.78.79.79,0,0,1-.77-.78.81.81,0,0,1,.75-.75A.76.76,0,0,1,29.56,50.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.88,50.26a.74.74,0,0,1-.68.78.77.77,0,0,1-.79-.76.81.81,0,0,1,.73-.76A.77.77,0,0,1,32.88,50.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.21,50.28a.75.75,0,0,1-.72.76.79.79,0,0,1-.76-.73.81.81,0,0,1,.76-.79A.77.77,0,0,1,36.21,50.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.53,50.27a.76.76,0,0,1-.71.78.79.79,0,0,1-.77-.78.81.81,0,0,1,.75-.75A.78.78,0,0,1,39.53,50.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.85,50.26a.75.75,0,0,1-.69.78.77.77,0,0,1-.79-.76.81.81,0,0,1,.74-.76A.77.77,0,0,1,42.85,50.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.42,31.79a.68.68,0,0,1,.75.69.75.75,0,0,1-.74.78.76.76,0,0,1-.73-.75A.68.68,0,0,1,12.42,31.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.29,47.33A.68.68,0,0,1,3,46.6a.7.7,0,0,1,.76.69.78.78,0,0,1-.75.79A.77.77,0,0,1,2.29,47.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.55,50.08a.73.73,0,0,1-.63-.83.69.69,0,0,1,.84-.64.73.73,0,0,1,.64.78A.8.8,0,0,1,5.55,50.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.64,33.32a.67.67,0,0,1-.71.73.72.72,0,0,1-.76-.7.77.77,0,0,1,.76-.77A.73.73,0,0,1,6.64,33.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.51,35.27a.69.69,0,0,1,.69-.75.73.73,0,0,1,.78.69.82.82,0,0,1-.74.81A.78.78,0,0,1,2.51,35.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.53,50.33a.67.67,0,0,1-.71.64.72.72,0,0,1-.76-.75.78.78,0,0,1,.75-.72A.73.73,0,0,1,9.53,50.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.4,38.75A.76.76,0,0,1,.68,38a.77.77,0,0,1,.75-.73A.82.82,0,0,1,2.2,38,.83.83,0,0,1,1.4,38.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,10.62A3.43,3.43,0,0,1,3.59,7.36c0-.58.2-.87.67-.9s.78.28.83.83a1.89,1.89,0,1,0,2-2c-.63-.08-.84-.29-.82-.8s.3-.69.93-.68a3.39,3.39,0,0,1,.67,6.66C7.57,10.54,7.25,10.57,7,10.62Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev10);
export default __webpack_public_path__ + "static/media/Dev10.5497f1381626b253a41f57a536bd5a4d.svg";
export { ForwardRef as ReactComponent };